__turbopack_context__.v({
  "blok-big-title": "CorrectionsBlok-module__DXwFLa__blok-big-title",
  "blok-subtitle": "CorrectionsBlok-module__DXwFLa__blok-subtitle",
  "blok-title": "CorrectionsBlok-module__DXwFLa__blok-title",
  "correctionLink": "CorrectionsBlok-module__DXwFLa__correctionLink",
  "downloadButton": "CorrectionsBlok-module__DXwFLa__downloadButton",
  "filters": "CorrectionsBlok-module__DXwFLa__filters",
  "icon": "CorrectionsBlok-module__DXwFLa__icon",
  "isLoading": "CorrectionsBlok-module__DXwFLa__isLoading",
});
